var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c("div", { staticClass: "modal-content" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c("img", {
        staticClass: "modal-footer-close-btn",
        attrs: { src: _vm.imageUrl("close-modal.png") },
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.closeModal.apply(null, arguments)
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fcbf119", { render: render, staticRenderFns: staticRenderFns })
  }
}